import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Bestellen aan tafel',
    [ORDER_METHODS.PICKUP]: 'Afhalen',
    [ORDER_METHODS.DELIVERY]: 'Bezorging',
  },
};
